const mazda = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "MAZDA3 SEDAN",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-3.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/mazda3-19.png"),
          trims: ["Base", "Select", "Preferred", "Premium"]
        }, 
        {
          modelName: "MAZDA3 HATCHBACK",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-hatchback.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/03mazda-hatchback-angle.png"),
          trims: ["Base", "Select", "Preferred", "Premium"]
        },
        {
          modelName: "MAZDA MX-5 Miata",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-miata.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/miata-gt-19.png"),
          trims: ["Sport", "Club", "Grand Touring"]
        }, 
        {
          modelName: "MAZDA MX-5 Miata RF",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-miata-rf.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/03mazda-miata-rf-angle.png"),
          trims: ["Sport", "Club", "Grand Touring"]
        },
      ],
      suvs: [
        {
          modelName: "MAZDA CX-30",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-cx30.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/cx30-20.png"),
          trims: ["2.5S", "Select", "Preferred", "Premium", "2.5 Turbo", "Turbo Premium", "Turbo Premium Plus"]
        },
        {
          modelName: "MAZDA CX-5",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-cx5.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/cx5-gt-19.png"),
          trims: ["Sport", "Touring", "Grand Touring", "Grand Touring Reserve", "Signature"]
        }, 
        {
          modelName: "MAZDA CX-50",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-cx50.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/03mazda-cx50-angle.png"),
          trims: ["Sport", "Touring", "Grand Touring", "Grand Touring Reserve", "Signature"]
        },
        {
          modelName: "MAZDA CX-9",
          sideView: require("../../../static/images/carcuts/mazda/side-view/03mazda-cx9.png"),
          angleView: require("../../../static/images/carcuts/mazda/angle-view/cx9-gt-19.png"),
          trims: ["Sport", "Touring", "Carbon Edition", "Grand Touring", "Signature"]
        },
      ],
      trucks: [],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/mazda/lifestyle/mazda-miata.jpg"),
        sedanImage: require("../../../static/images/carcuts/mazda/lifestyle/mazda6-20.jpg"),
        suvImage: require("../../../static/images/carcuts/mazda/lifestyle/cx9-21.jpg"),
        truckImage: require("../../../static/images/carcuts/mazda/lifestyle/cx30-21.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/progressive_redirect/playback/736991798/rendition/1080p/file.mp4?loc=external&signature=06448b1b58b02333d436beebef4df65acbd294d54ae15784c45008a9f3c4c3bb"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/mazda-New.png"), require("../../../static/images/buttons/round-buttons/mazda-Used.png"), require("../../../static/images/buttons/round-buttons/mazda-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/mazda-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/black-new.png"), require("../../../static/images/buttons/browse-buttons/black-used.png"), require("../../../static/images/buttons/browse-buttons/black-service.png"), require("../../../static/images/buttons/browse-buttons/black-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/black01.png"), require("../../../static/images/buttons/swoop-icons/black03.png"), require("../../../static/images/buttons/swoop-icons/black02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/mazda/CM-KT-24-Mazda-Established.jpg"), require("../../../static/images/banners/mazda/CM-KT-24-Mazda-Lifestyle.jpg"), require("../../../static/images/banners/mazda/CM-KT-24-Mazda-Modern.jpg"), require("../../../static/images/banners/mazda/CM-KT-24-Mazda-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/mazda/SOKAL-SRS-112321-DealerDraftMazda-Established2.jpeg"), require("../../../static/images/banners/mazda/SOKAL-SRS-112321-DealerDraftMazda-Lifestyle1.jpeg"), require("../../../static/images/banners/mazda/SOKAL-SRS-112321-DealerDraftMazda-Modern3.jpeg"), require("../../../static/images/banners/mazda/SOKAL-SRS-112321-DealerDraftMazda-Playful5.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-mazda.png"),
        require("../../../static/images/buttons/logos/dd-logo-mazda-w.png")
      ]
    },
   colors: {
      "--primary-color": "#2b2b2b",
      "--primary-dark": "#101010",
      "--primary-light": "#fff",
      "--secondary-color": "#7f7f7f",
      "--secondary-dark": "#000",
      "--secondary-light": "#d8d8d8",
    },
    fonts: {
      "--heading-text": "Mazda-Bold, Arial, sans-serif",
      "--subheading-text": "Mazda-Bold, Arial, sans-serif",
      "--body-text": "Mazda-Regular, Arial, sans-serif",
      "--bold-text": "Mazda-Bold, Arial, sans-serif"
    }
  })
}


export default mazda